"use client";

import Link from "next/link";

// Server-side failures are already recorded in the admin error log (src/lib/blog.ts).
export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <div className="lp-center container mx-auto max-w-2xl px-4 pt-40 pb-28 text-center">
      <p className="lp-eyebrow mb-5">Something went wrong</p>
      <h1 className="lp-h1 !text-[clamp(2rem,4.5vw,3.2rem)]">We couldn&apos;t load this page.</h1>
      <p className="mt-5 text-[17px] leading-relaxed text-lp-ink-2">
        It&apos;s usually temporary. Try again in a moment, and if it keeps happening, tell us at support@authorflows.com.
      </p>
      <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
        <button type="button" onClick={reset} className="lp-btn">
          Try again
        </button>
        <Link href="/blogs" className="lp-btn-secondary">
          Back to the blog
        </Link>
      </div>
      {process.env.NODE_ENV === "development" && (
        <pre className="mt-8 whitespace-pre-wrap rounded-xl border border-lp-rule bg-lp-paper p-4 text-left text-xs text-lp-ink-2">
          {error.message}
        </pre>
      )}
    </div>
  );
}
